module.exports = __webpack_public_path__ + "static/media/wishlist.e3538674.svg";